export default __webpack_public_path__ + "static/media/calconvert_xl1.9268a423.png";